import { EscrowOfficerComponent, EscrowOfficerComponentProperties } from './escrow-officer.component';
import { EscrowOfficerState } from '../../escrow-officer.reducer';
import { connect, Dispatch } from 'react-redux';
import { createEscrowOfficer, lookupOffice, getEscrowOfficer, editEscrowOfficer } from '../../escrow-officer.actions';
import { AppState } from '../../..';
import { actions } from 'react-redux-form';
import FormNames from '@constants/FormNames.enum';
import { EscrowOfficerViewModel } from '@models/EscrowOfficer';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(newState: AppState): Partial<EscrowOfficerComponentProperties> {
  return {
    errorMessage: newState.escrowOfficer.errorMessage,
    statusMessage: newState.escrowOfficer.statusMessage,
    saving: newState.escrowOfficer.saving
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(
  dispatch: Dispatch<EscrowOfficerState>,
  ownProps: { saveCallback: Function; entityId: number }
): Partial<EscrowOfficerComponentProperties> {
  return {
    submit: (formData: EscrowOfficerViewModel, isModal: boolean) => {
      let newFormData = Object.assign({}, formData);
      const address = formData.address;
      if (address && !address.line1) {
        newFormData.address = null;
      }
      if (ownProps.entityId) {
        return dispatch(editEscrowOfficer(ownProps.entityId, newFormData, isModal, ownProps.saveCallback));
      }
      return dispatch(createEscrowOfficer(newFormData, isModal, ownProps.saveCallback));
    },
    officeLookup(value: string, id: number) {
      return lookupOffice(value, id);
    },
    getOfficer(id?: number) {
      return dispatch(getEscrowOfficer(id));
    },
    clearEscrowForm() {
      return dispatch(actions.reset(FormNames.EscrowOfficerForm));
    }
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const EscrowOfficer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EscrowOfficerComponent);



// WEBPACK FOOTER //
// ./src/escrow-officer/_components/escrow-officer/escrow-officer.container.ts